module.exports = __webpack_public_path__ + "static/media/verengte_fahrbahn.e21b4261.svg";